__turbopack_context__.v({
  "container": "menuList-module-scss-module__VfY8WW__container",
  "line": "menuList-module-scss-module__VfY8WW__line",
  "link": "menuList-module-scss-module__VfY8WW__link",
  "wide": "menuList-module-scss-module__VfY8WW__wide",
});
